import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { SolutionsPresentationProps, SolutionData } from '../types';
import SolutionCardPresentation from './SolutionCardPresentation';
import { SectionAnchor } from '../../../shared/components';

const SolutionsPresentation: React.FC<SolutionsPresentationProps> = ({
  id,
  heading,
  description,
  solutions
}) => {
  return (
    <>
      <SectionAnchor id={id} />
      <Box
        as="section"
        pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}
      >
      <Container maxW="container.xl">
        <Box textAlign="center" mb={16} maxW="800px" mx="auto">
          <Heading 
            as="h2" 
            size="xl" 
            mb={4}
            bgGradient="linear(to-r, brand.primary.dark, brand.primary.base)"
            bgClip="text"
          >
            {heading}
          </Heading>
          <Text fontSize="lg" color="gray.600">
            {description}
          </Text>
        </Box>
        
        <VStack spacing={6} align="stretch">
          {solutions.map((solution: SolutionData, index: number) => (
            <SolutionCardPresentation 
              key={index}
              title={solution.title}
              description={solution.description}
              icon={solution.icon}
              benefits={solution.benefits}
              isReversed={index % 2 !== 0}
            />
          ))}
        </VStack>
      </Container>
    </Box>
    </>
  );
};

export default SolutionsPresentation;